import request from '@/../../common/src/utils/requests/request';
import { ProductType } from '@/AppGlobal';
import { EddaBankInfo, EddaManageResponseDTO } from '@/interface/KKC/edda';

//
export const getList = (params: any) => request.post(``, params);

export const updateEddaBinding = (fillInItems: EddaBankInfo) =>
  request.post<{
    msgId: string;
  }>('credit/binding/update', fillInItems, { loading: true });

// 更新默认还款卡
export const updateCardbinding = (fillInItems: {
  msgId?: string | number;
  msgIdList?: {
    msgId: string;
    productCode: ProductType;
  }[];
}) => request.post<string>('credit/binding/updateCard', fillInItems, { loading: true });

// Edda 確認資料接口参数类型
export interface QueryEddaManageInfoParams {
  eddaApplyId?: string;
}

// Edda 確認資料接口
export const queryEddaManageInfo = (params?: QueryEddaManageInfoParams) =>
  request.post<EddaManageResponseDTO>('/credit/binding/selectEddaNode', params || {});

// Edda 管理-修改數據
export const saveEddaManageInfo = (data: Partial<EddaManageResponseDTO>) =>
  request.post('/credit/binding/updateOrSave', data);
